import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import EventRegistration from 'components/UI/Event/EventRegistration';

const EventRegistrationStyled = withStyles((theme) => ({
  root: {
    '& .MuiTypography-h1': {
      marginBottom: theme.spacing(3),
    },

    '& .MuiTypography-h5': {
      fontSize: '1.075rem',
      fontWeight: 600
    },
    '& .MuiButton-textSecondary': {
      color: theme.palette.primary.dark,
      textDecoration: 'underline'
    },
    '& .MuiButton-containedPrimary': {
    },
    '& .MuiMenuItem-root': {
      display: 'inline-block',
      color: theme.palette.secondary.dark,
      backgroundColor: 'transparent',
      width: '50%',
      marginRight: 0,
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      }
    },

  },
  header: {
    backgroundColor: 'transparent',
    '&:before': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      content: "' '",
      // height: '160px',
      height: '220px',
      backgroundColor: theme.palette.secondary.dark,
      // backgroundImage: 'url('+require('assets/images/header_registration.jpg')+')',
      backgroundPosition: '50% 100%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      zIndex: -1,
    },
  },
  // whiteBg: {
  //   '&:before': {
  //     backgroundColor: 'transparent',
  //   },
  // },
  titleIcon: {
    //backgroundImage: 'url(' + require('assets/images/logo.png') + ')',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 50%',
    backgroundColor: '#fff',
    backgroundSize: '70%',
  },
  left: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    border: 'none',
    // marginBottom: '-170px',
    width: '80%',
    maxWidth: 960,
  },
  formWrapper: {
    marginTop: 0,
  },

  column: {
    padding: 0,
    '&:before': {
      border: 'none'
    }
  },
  formGroup: {
    '&:before': {
      border: 'none',
    },
    marginBottom: theme.spacing(2)
  },
  jobForm: {
    maxWidth: 440,
    display: 'block',
    margin: '0 auto',
    '& .MuiButton-containedPrimary': {
      display: 'block'
    },
  },
  subscriptionFormNotice: {
    textAlign: 'left',
  }

}))(EventRegistration);

class EventRegistrationWrapper extends Component {
  render() {
    return <EventRegistrationStyled templateProps={{ kind: 'fullWidth', maxWidth: 'auto' }} />;
  }
}

export default EventRegistrationWrapper;




// WEBPACK FOOTER //
// ./src/components/Event/EventRegistration.jsx